import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Hero from "@/components/sections/Hero";
import About from "@/components/sections/About";
import Rooms from "@/components/sections/Rooms";
import Services from "@/components/sections/Services";
import Attractions from "@/components/sections/Attractions";
import Reviews from "@/components/sections/Reviews";
import HowToReach from "@/components/sections/HowToReach";
import Contact from "@/components/sections/Contact";
import Gallery from "@/components/sections/Gallery";
import PromoPopup from "@/components/PromoPopup";
import { useEffect } from "react";
import { trackPageView } from "@/lib/analytics";

export default function HomePage() {
  useEffect(() => { trackPageView(); }, []);
  return (
    <div className="min-h-screen bg-[#FDFBF7]">
      <Header />
      <main>
        <Hero />
        <About />
        <Rooms />
        <Gallery />
        <Services />
        <Attractions />
        <Reviews />
        <HowToReach />
        <Contact />
      </main>
      <Footer />
      <PromoPopup />
    </div>
  );
}
